import React from 'react';

export default function EmptyForm() {
    return (
        <div className="w-4/5 h-100 flex flex-grow justify-center items-center">
            <p className="text-2xl px-6">Please select how you would like to interact with the features database on the left.</p>
        </div>
    )
}